import * as React from "react";
import styled from "styled-components";
const TwentyFourTip = styled.div `
	height: 16px;
	font-size: 12px;
	color: #666666;
	line-height: 16px;
	margin-top: 5px;
`;
export const TwentyFour = (props) => {
    const { text } = props;
    return React.createElement(TwentyFourTip, null, text);
};
